import { Box, Flex, DeprecatedIcon, InlineLink, Text, Tooltip } from '@fullstory/components';
import { generateRoutePath, SETTINGS_BILLING } from '@fullstory/routes';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SessionInfoUnavailable: React.FC<{
  retentionWindowInMonths: number;
  orgId: string;
}> = ({ retentionWindowInMonths, orgId }) => (
  <Flex data-component="SessionInfoUnavailable" justifyContent="flex-start">
    <Box marginRight={8} overflow="hidden">
      <Text appearance="bodySmall" color="disabled" noWrap>
        <FormattedMessage defaultMessage="Session unavailable" id="L0004M" />
      </Text>
    </Box>

    <Tooltip
      placement="top"
      tooltipContent={
        <Text appearance="bodySmall" color="default-inverse">
          <FormattedMessage
            defaultMessage="Only sessions from the last {retentionWindowInMonths} months are available. For more details, go to <link>Subscription</link>."
            id="3BkwHR"
            values={{
              link(text) {
                return (
                  <InlineLink to={generateRoutePath(SETTINGS_BILLING, { orgId })} variant="inverse">
                    {text}
                  </InlineLink>
                );
              },
              retentionWindowInMonths,
            }}
          />
        </Text>
      }
    >
      <Box flexShrink={0}>
        <DeprecatedIcon name="information-primary" size={16} color="neutrals-n7" />
      </Box>
    </Tooltip>
  </Flex>
);
